export const ActClassroomOptions = ({placeholder = 'All classrooms'}) => {
  const classrooms = useActClassrooms().sort((a, b) => a.name.localeCompare(b.name))

  return pug`
    option(value='')= placeholder
    for classroom in classrooms
      option(key=classroom.id value=classroom.id)= classroom.name
  `
}
